import {observable} from "@nx-js/observer-util";
import {Services} from "../../Services";
import {IOfferInvoiceModel} from "../../../models/offer/invoice/IOfferInvoiceModel";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {Resources} from "../../../resources/Resources";

export class OfferInvoiceService {
    public static invoices: IOfferInvoiceModel[] = observable([]);

    public static dispose(): void {
        this.invoices = observable([]);
    }

    public static init(): void {

    }

    public static async all(component?: INetworkComponent): Promise<IOfferInvoiceModel[]> {
        let request = await Network.get(ProductType.PANEL, `/offer/invoices`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async download(invoiceId: string, component?: INetworkComponent): Promise<string> {
        let request = await Network.get(ProductType.PANEL, `/offer/invoice/${invoiceId}/export/invoice`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async charge(invoiceId: string, component?: INetworkComponent): Promise<string> {
        Services.handleErrors(component, [
            {
                status: HttpStatus.NOT_FOUND,
                message: Resources.t("words.receiptNotAvailable")
            },
        ]);


        let request = await Network.get(ProductType.PANEL, `/offer/invoice/${invoiceId}/export/receipt`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    /**
     * store
     */
    public static storeAll(invoices: IOfferInvoiceModel[]): IOfferInvoiceModel[] {
        for (let key in invoices)
            invoices[key] = this.store(invoices[key]);

        return Services.storeAll(invoices);
    }

    public static store(invoice: IOfferInvoiceModel): IOfferInvoiceModel {
        invoice = Services.store("id", this.invoices, invoice);
        return invoice;
    }
}